module.exports = __webpack_public_path__ + "img/115.c45a35d6.png";